export default __webpack_public_path__ + "static/media/green25Discount@3x.e469f817.png";